import { render } from "./DatabaseBackup.vue?vue&type=template&id=19f3b5dc&scoped=true"
import script from "./DatabaseBackup.vue?vue&type=script&lang=js"
export * from "./DatabaseBackup.vue?vue&type=script&lang=js"

import "./DatabaseBackup.vue?vue&type=style&index=0&id=19f3b5dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f3b5dc"]])

export default __exports__